import { createFileRoute } from "@tanstack/react-router";
import { AuditPage } from "@/components/audit/AuditPage";
import { auditHead } from "@/components/audit/auditHead";

// Cold-email entry point: renders /audit unchanged; canonical (via auditHead) points to /audit.
export const Route = createFileRoute("/audit_/e")({
  head: auditHead,
  component: AuditPage,
});
